import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { formatAmount } from './../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';

/* Shops Warehouse Delivery — summary view.

   The legacy report's "By Summary" mode (SP_MS_FMS_RptShopWarehouseDelivery_Query with
   @P_Index = 1) produced one row per warehouse:
       WarehouseName | BalanceBF | TDeliverAmount | PayToWarehouse
   where BalanceBF = (account opening balance + prior deliveries) - prior payments.

   Those three figures are ALREADY computed by services/report/warehouseBalance.php — the
   endpoint behind the Warehouse Balance report — so this view renders that endpoint's
   output rather than recomputing anything. Reimplementing the arithmetic would risk the
   two reports disagreeing, which is the failure mode this whole exercise exists to avoid.

   Mapping: OPENING_BALANCE -> Balance B/F, TOTAL_DELIVERY -> Delivery,
            TOTAL_PAYMENT   -> Pay To Warehouse.
   Net follows legacy's own definition: Balance B/F + Delivery - Pay To Warehouse. */

const headCell = { background: '#f1f1f1', color: '#111827', fontWeight: 600 };
const numCell = { textAlign: 'right' };

class Summary extends Component {

    render() {
        const { ReportDetails = {}, WarehouseName = "", WeekRange = "" } = this.props;

        const bf = +ReportDetails.OPENING_BALANCE || 0;
        const delivery = +ReportDetails.TOTAL_DELIVERY || 0;
        const payment = +ReportDetails.TOTAL_PAYMENT || 0;
        const net = bf + delivery - payment;

        return (
            <section>
                <SectionHeader title={<>{WeekRange}</>} />

                <Row>
                    <Col md={12} >
                        <Paper>
                            <TableContainer className="report-table-container" >
                                <Table className="report-table" size="small" aria-label="warehouse delivery summary">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={headCell} >Warehouse</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Balance B/F</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Delivery</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Pay To Warehouse</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Net Balance</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow >
                                            <TableCell>{WarehouseName}</TableCell>
                                            <TableCell style={numCell} >{formatAmount(bf)}</TableCell>
                                            <TableCell style={numCell} >{formatAmount(delivery)}</TableCell>
                                            <TableCell style={numCell} >{formatAmount(payment)}</TableCell>
                                            <TableCell style={{ ...numCell, fontWeight: 700 }} >{formatAmount(net)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>

                        <div style={{ color: '#555', fontSize: '12px', padding: '8px 4px' }} >
                            Figures come from the same source as the Warehouse Balance report, so the two
                            always agree. Legacy also carried the warehouse account's static opening balance
                            into Balance B/F; the rewrite has no warehouse-to-account link, so Balance B/F
                            here is prior deliveries less prior payments.
                        </div>
                    </Col>
                </Row>
            </section>
        );
    }
}

export default Summary;
